import React, { FC } from 'react';
import TimeDisplayInStaticFormat from '@components/common/TimeDisplayInStaticFormat';
import ColorWrapper from '@styles/colors';
import { ColorFunction } from '@styles/colors/types';
import { useManageBatchBlockTime } from '@v2/pages/machines/modules/now/components/Overview/components/BatchBlock/hooks/useManageBatchBlockTime';
import { useSelector } from 'react-redux';
import { selectSingleBatch } from '@reducers/batch';
import { ProductionBatchStatistics } from '@interfaces/search';
import { View } from 'react-native';
import { ContainerStyle } from '@interfaces/base';

interface BatchBlockTimeProps extends ContainerStyle {
  C: ColorFunction;
}

const BatchBlockTime: FC<BatchBlockTimeProps> = ({ C, containerStyle }) => {
  const batch: ProductionBatchStatistics = useSelector(selectSingleBatch);
  const { timeValue } = useManageBatchBlockTime();

  return (
    <View style={[{ alignItems: 'center', width: '100%' }, containerStyle]}>
      <TimeDisplayInStaticFormat
        C={C}
        timeValue={timeValue}
        fontForDigit="Time XXXXL"
        fontForSecondDigit="Time XXXL"
        fontForDelimiter="Time XXXXL"
        fontForSecondDelimiter="Time XXXL"
        color="Label/Light/Primary"
        shouldRunTime={batch?.isInProgress}
        delimiterAlignCenter={false}
      />
    </View>
  );
};

export default ColorWrapper(BatchBlockTime);
